export class Util {

    /**
     * Count decimal parts of given number
     */
    static countDecimals(val) {

        if (Math.floor(val.valueOf()) === val.valueOf()) return 0;

        let splittedArr = val.toString().split(".");
        if (splittedArr.length == 2) {
            return val.toString().split(".")[1].length || 0;
        } else {
            return 0;
        }

    }

    /**
     * Replace url segments and give actual url
     */
    static replaceUrlSegments(url, mapObj): string {

        let formattedUrl = url;
        let r = new RegExp(':(.*?)(/|$)', 'gi');

        let match;
        while ((match = r.exec(url)) != null) {
            formattedUrl = formattedUrl.replace(new RegExp(':' + match[1], 'g'), mapObj[match[1]])
        }

        return formattedUrl;
    }

    /**
     * Replace api url parameters and give replaced url
     */
    static replaceApiUrlParams(url, mapObj): string {

        let formattedUrl = url;
        let r = new RegExp('{(.*?)}', 'gi');

        let match;
        while ((match = r.exec(url)) != null) {
            formattedUrl = formattedUrl.replace(new RegExp(match[0], 'g'), mapObj[match[1]])
        }

        return formattedUrl;
    }

    static getFileExtintion(fileName): string {
        if (fileName) {
            let file = fileName.split('.');
            let extintion = file[file.length - 1]
            return extintion;
        }
        return 'other';
    }

    static getDateObject(dateValue?: string): any {
        let date = dateValue ? new Date(dateValue) : new Date();
        let yyyy = date.getFullYear().toString();
        let mm = (date.getMonth() + 1).toString();
        let dd = date.getDate().toString();

        let mmChars = mm.split('');
        let ddChars = dd.split('');
        return {
            date: {
                year: yyyy,
                month: mm,
                day: dd
            },
            formatted: dateValue ? dateValue :
                yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0])
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/util.ts